module.exports = __webpack_public_path__ + "static/media/lunas.c9d5c417.png";